'use client';
import React, { useState } from 'react';
import { reviews } from '@/data/reviews';
import { StarIcon } from '@heroicons/react/24/solid';

const filters = [
  { label: 'All', value: 'all' },
  { label: 'Console', value: 'console' },
  { label: 'Phone', value: 'phone' },
  { label: 'Laptop', value: 'laptop' },
  { label: 'Computer', value: 'computer' },
  { label: 'Other', value: 'other' },
];

const IS_PRODUCTION = process.env.NODE_ENV === 'production';

export default function ReviewsClient() {
  const [activeFilter, setActiveFilter] = useState('all');

  const filtered = reviews?.filter((r) => {
    if (IS_PRODUCTION && r?.isPlaceholder) return false;
    if (activeFilter === 'all') return true;
    return r?.category === activeFilter;
  });

  return (
    <div>
      {/* Filter tabs */}
      <div className="flex flex-wrap gap-2 mb-8">
        {filters?.map((f) => (
          <button
            key={f?.value}
            onClick={() => setActiveFilter(f?.value)}
            className="px-4 py-2 rounded-full text-sm font-semibold border transition-all"
            style={{
              backgroundColor: activeFilter === f?.value ? 'var(--brand)' : 'var(--surface)',
              borderColor: activeFilter === f?.value ? 'var(--brand)' : 'var(--border-color)',
              color: activeFilter === f?.value ? 'var(--bg)' : 'var(--text)',
            }}
          >
            {f?.label}
          </button>
        ))}
      </div>

      {filtered?.length === 0 ? (
        <div className="text-center py-12">
          <p className="text-sm" style={{ color: 'var(--text-muted)' }}>
            No reviews available for this category yet. Check back soon, or read all our reviews on Google.
          </p>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {filtered?.map((review) => (
            <div
              key={review?.id}
              className="flex flex-col p-5 rounded-xl card-hover"
              style={{ backgroundColor: 'var(--surface)', border: '1px solid var(--border-color)' }}
            >
              {!IS_PRODUCTION && review?.isPlaceholder && (
                <div
                  className="mb-3 px-2.5 py-1.5 rounded-lg text-xs font-medium"
                  style={{ backgroundColor: 'rgba(251,188,5,0.1)', color: '#FBBC05', border: '1px solid rgba(251,188,5,0.2)' }}
                >
                  ⚠ Sample review. Replace with verified Google review.
                </div>
              )}
              <div className="flex mb-3">
                {[1,2,3,4,5]?.map((s) => (
                  <StarIcon key={s} className="w-4 h-4" style={{ color: s <= review?.stars ? '#FBBC05' : 'var(--border-color)' }} />
                ))}
              </div>
              <p className="text-sm leading-relaxed flex-1 mb-4" style={{ color: 'var(--text-muted)' }}>
                "{review?.text}"
              </p>
              <div className="flex items-center justify-between mt-auto pt-3 border-t" style={{ borderColor: 'var(--border-color)' }}>
                <div>
                  <div className="text-sm font-semibold" style={{ color: 'var(--text)' }}>{review?.name}</div>
                  <div className="text-xs mt-0.5" style={{ color: 'var(--text-muted)' }}>Posted on Google · {review?.date}</div>
                </div>
                <span
                  className="text-xs font-medium px-2 py-1 rounded-full capitalize"
                  style={{ backgroundColor: 'var(--surface-2)', border: '1px solid var(--border-color)', color: 'var(--text-muted)' }}
                >
                  {review?.category}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}